import { useAppContext } from "@kunduz/feature-website-context";
import { HeaderLogo } from "@kunduz/ui-components";
import React, { ReactElement } from "react";
import CoinIconActive from "@icons/coinIconActive.svg";
import { Infinity, User01 } from "@untitled-ui/icons-react";
import styles from "./mobileLogo.module.scss";
import { Avatar } from "@kunduz/ui-atoms";
import Link from "next/link";

export const MobileLogo = (props: Props): ReactElement => {
  const { student, profiles } = useAppContext();
  return (
    <div className={styles.wrapper}>
      <HeaderLogo linkPath={props.lang == "tr" ? "/tr/" : "/"} />

      {student?.data && (
        <div className={styles.dataWrapper}>
          <CoinIconActive width={20} height={20} />{" "}
          {student?.data?.limits?.questions?.is_unlimited ? (
            <Infinity viewBox="0 0 24 24" />
          ) : (
            student?.data?.limits?.questions?.remained
          )}
        </div>
      )}

      {profiles && (
        <Link href="/u/" locale={false}>
          <Avatar
            text={`${profiles.first_name} ${profiles.last_name}`}
            placeholderIcon={User01}
            size="sm"
          />
        </Link>
      )}
    </div>
  );
};

interface Props {
  lang: "tr" | "en";
}
